import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../constants';

const Button = props => {
  const {
    id,
    className,
    onClick,
    text,
    imageWidth,
    imageSrc,
    imageAlt,
  } = props;
  return (
    <button
      id={id}
      key={id}
      className={className}
      type='button'
      onClick={onClick}
    >
      {text}
      {imageSrc && (
        <img src={`${BASE_URL}${imageSrc}`} alt={imageAlt} width={imageWidth} />
      )}
    </button>
  );
};

Button.defaultProps = {
  id: null,
  className: '',
  onClick: null,
  text: '',
  imageSrc: '',
  imageAlt: '',
  imageWidth: null,
};

Button.propTypes = {
  id: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageWidth: PropTypes.number,
};
export default Button;
